type DomesticCodesType = {
  [key: string]: { code: string; cities: { [key: string]: { code: string } } };
};

export const domesticCodes: DomesticCodesType = {
  北京: {
    code: '11',
    cities: {
      市辖区: {
        code: '110000',
      },
    },
  },
  天津: {
    code: '12',
    cities: {
      市辖区: {
        code: '120000',
      },
    },
  },
  河北: {
    code: '13',
    cities: {
      石家庄市: {
        code: '130100',
      },
      唐山市: {
        code: '130200',
      },
      秦皇岛市: {
        code: '130300',
      },
      邯郸市: {
        code: '130400',
      },
      邢台市: {
        code: '130500',
      },
      保定市: {
        code: '130600',
      },
      张家口市: {
        code: '130700',
      },
      承德市: {
        code: '130800',
      },
      沧州市: {
        code: '130900',
      },
      廊坊市: {
        code: '131000',
      },
      衡水市: {
        code: '131100',
      },
    },
  },
  山西: {
    code: '14',
    cities: {
      太原市: {
        code: '140100',
      },
      大同市: {
        code: '140200',
      },
      阳泉市: {
        code: '140300',
      },
      长治市: {
        code: '140400',
      },
      晋城市: {
        code: '140500',
      },
      朔州市: {
        code: '140600',
      },
      晋中市: {
        code: '140700',
      },
      运城市: {
        code: '140800',
      },
      忻州市: {
        code: '140900',
      },
      临汾市: {
        code: '141000',
      },
      吕梁市: {
        code: '141100',
      },
    },
  },
  内蒙古: {
    code: '15',
    cities: {
      呼和浩特市: {
        code: '150100',
      },
      包头市: {
        code: '150200',
      },
      乌海市: {
        code: '150300',
      },
      赤峰市: {
        code: '150400',
      },
      通辽市: {
        code: '150500',
      },
      鄂尔多斯市: {
        code: '150600',
      },
      呼伦贝尔市: {
        code: '150700',
      },
      巴彦淖尔市: {
        code: '150800',
      },
      乌兰察布市: {
        code: '150900',
      },
      兴安盟: {
        code: '152200',
      },
      锡林郭勒盟: {
        code: '152500',
      },
      阿拉善盟: {
        code: '152900',
      },
    },
  },
  辽宁: {
    code: '21',
    cities: {
      沈阳市: {
        code: '210100',
      },
      大连市: {
        code: '210200',
      },
      鞍山市: {
        code: '210300',
      },
      抚顺市: {
        code: '210400',
      },
      本溪市: {
        code: '210500',
      },
      丹东市: {
        code: '210600',
      },
      锦州市: {
        code: '210700',
      },
      营口市: {
        code: '210800',
      },
      阜新市: {
        code: '210900',
      },
      辽阳市: {
        code: '211000',
      },
      盘锦市: {
        code: '211100',
      },
      铁岭市: {
        code: '211200',
      },
      朝阳市: {
        code: '211300',
      },
      葫芦岛市: {
        code: '211400',
      },
    },
  },
  吉林: {
    code: '22',
    cities: {
      长春市: {
        code: '220100',
      },
      吉林市: {
        code: '220200',
      },
      四平市: {
        code: '220300',
      },
      辽源市: {
        code: '220400',
      },
      通化市: {
        code: '220500',
      },
      白山市: {
        code: '220600',
      },
      松原市: {
        code: '220700',
      },
      白城市: {
        code: '220800',
      },
      延边朝鲜族自治州: {
        code: '222400',
      },
    },
  },
  黑龙江: {
    code: '23',
    cities: {
      哈尔滨市: {
        code: '230100',
      },
      齐齐哈尔市: {
        code: '230200',
      },
      鸡西市: {
        code: '230300',
      },
      鹤岗市: {
        code: '230400',
      },
      双鸭山市: {
        code: '230500',
      },
      大庆市: {
        code: '230600',
      },
      伊春市: {
        code: '230700',
      },
      佳木斯市: {
        code: '230800',
      },
      七台河市: {
        code: '230900',
      },
      牡丹江市: {
        code: '231000',
      },
      黑河市: {
        code: '231100',
      },
      绥化市: {
        code: '231200',
      },
      大兴安岭地区: {
        code: '232700',
      },
    },
  },
  上海: {
    code: '31',
    cities: {
      市辖区: {
        code: '310000',
      },
    },
  },
  江苏: {
    code: '32',
    cities: {
      南京市: {
        code: '320100',
      },
      无锡市: {
        code: '320200',
      },
      徐州市: {
        code: '320300',
      },
      常州市: {
        code: '320400',
      },
      苏州市: {
        code: '320500',
      },
      南通市: {
        code: '320600',
      },
      连云港市: {
        code: '320700',
      },
      淮安市: {
        code: '320800',
      },
      盐城市: {
        code: '320900',
      },
      扬州市: {
        code: '321000',
      },
      镇江市: {
        code: '321100',
      },
      泰州市: {
        code: '321200',
      },
      宿迁市: {
        code: '321300',
      },
    },
  },
  浙江: {
    code: '33',
    cities: {
      杭州市: {
        code: '330100',
      },
      宁波市: {
        code: '330200',
      },
      温州市: {
        code: '330300',
      },
      嘉兴市: {
        code: '330400',
      },
      湖州市: {
        code: '330500',
      },
      绍兴市: {
        code: '330600',
      },
      金华市: {
        code: '330700',
      },
      衢州市: {
        code: '330800',
      },
      舟山市: {
        code: '330900',
      },
      台州市: {
        code: '331000',
      },
      丽水市: {
        code: '331100',
      },
    },
  },
  安徽: {
    code: '34',
    cities: {
      合肥市: {
        code: '340100',
      },
      芜湖市: {
        code: '340200',
      },
      蚌埠市: {
        code: '340300',
      },
      淮南市: {
        code: '340400',
      },
      马鞍山市: {
        code: '340500',
      },
      淮北市: {
        code: '340600',
      },
      铜陵市: {
        code: '340700',
      },
      安庆市: {
        code: '340800',
      },
      黄山市: {
        code: '341000',
      },
      滁州市: {
        code: '341100',
      },
      阜阳市: {
        code: '341200',
      },
      宿州市: {
        code: '341300',
      },
      六安市: {
        code: '341500',
      },
      亳州市: {
        code: '341600',
      },
      池州市: {
        code: '341700',
      },
      宣城市: {
        code: '341800',
      },
    },
  },
  福建: {
    code: '35',
    cities: {
      福州市: {
        code: '350100',
      },
      厦门市: {
        code: '350200',
      },
      莆田市: {
        code: '350300',
      },
      三明市: {
        code: '350400',
      },
      泉州市: {
        code: '350500',
      },
      漳州市: {
        code: '350600',
      },
      南平市: {
        code: '350700',
      },
      龙岩市: {
        code: '350800',
      },
      宁德市: {
        code: '350900',
      },
    },
  },
  江西: {
    code: '36',
    cities: {
      南昌市: {
        code: '360100',
      },
      景德镇市: {
        code: '360200',
      },
      萍乡市: {
        code: '360300',
      },
      九江市: {
        code: '360400',
      },
      新余市: {
        code: '360500',
      },
      鹰潭市: {
        code: '360600',
      },
      赣州市: {
        code: '360700',
      },
      吉安市: {
        code: '360800',
      },
      宜春市: {
        code: '360900',
      },
      抚州市: {
        code: '361000',
      },
      上饶市: {
        code: '361100',
      },
    },
  },
  山东: {
    code: '37',
    cities: {
      济南市: {
        code: '370100',
      },
      青岛市: {
        code: '370200',
      },
      淄博市: {
        code: '370300',
      },
      枣庄市: {
        code: '370400',
      },
      东营市: {
        code: '370500',
      },
      烟台市: {
        code: '370600',
      },
      潍坊市: {
        code: '370700',
      },
      济宁市: {
        code: '370800',
      },
      泰安市: {
        code: '370900',
      },
      威海市: {
        code: '371000',
      },
      日照市: {
        code: '371100',
      },
      临沂市: {
        code: '371300',
      },
      德州市: {
        code: '371400',
      },
      聊城市: {
        code: '371500',
      },
      滨州市: {
        code: '371600',
      },
      菏泽市: {
        code: '371700',
      },
    },
  },
  河南: {
    code: '41',
    cities: {
      郑州市: {
        code: '410100',
      },
      开封市: {
        code: '410200',
      },
      洛阳市: {
        code: '410300',
      },
      平顶山市: {
        code: '410400',
      },
      安阳市: {
        code: '410500',
      },
      鹤壁市: {
        code: '410600',
      },
      新乡市: {
        code: '410700',
      },
      焦作市: {
        code: '410800',
      },
      濮阳市: {
        code: '410900',
      },
      许昌市: {
        code: '411000',
      },
      漯河市: {
        code: '411100',
      },
      三门峡市: {
        code: '411200',
      },
      南阳市: {
        code: '411300',
      },
      商丘市: {
        code: '411400',
      },
      信阳市: {
        code: '411500',
      },
      周口市: {
        code: '411600',
      },
      驻马店市: {
        code: '411700',
      },
      省直辖县级行政区划: {
        code: '4190000',
      },
    },
  },
  湖北: {
    code: '42',
    cities: {
      武汉市: {
        code: '420100',
      },
      黄石市: {
        code: '420200',
      },
      十堰市: {
        code: '420300',
      },
      宜昌市: {
        code: '420500',
      },
      襄阳市: {
        code: '420600',
      },
      鄂州市: {
        code: '420700',
      },
      荆门市: {
        code: '420800',
      },
      孝感市: {
        code: '420900',
      },
      荆州市: {
        code: '421000',
      },
      黄冈市: {
        code: '421100',
      },
      咸宁市: {
        code: '421200',
      },
      随州市: {
        code: '421300',
      },
      恩施土家族苗族自治州: {
        code: '422800',
      },
      省直辖县级行政区划: {
        code: '4290000',
      },
    },
  },
  湖南: {
    code: '43',
    cities: {
      长沙市: {
        code: '430100',
      },
      株洲市: {
        code: '430200',
      },
      湘潭市: {
        code: '430300',
      },
      衡阳市: {
        code: '430400',
      },
      邵阳市: {
        code: '430500',
      },
      岳阳市: {
        code: '430600',
      },
      常德市: {
        code: '430700',
      },
      张家界市: {
        code: '430800',
      },
      益阳市: {
        code: '430900',
      },
      郴州市: {
        code: '431000',
      },
      永州市: {
        code: '431100',
      },
      怀化市: {
        code: '431200',
      },
      娄底市: {
        code: '431300',
      },
      湘西土家族苗族自治州: {
        code: '433100',
      },
    },
  },
  广东: {
    code: '44',
    cities: {
      广州市: {
        code: '440100',
      },
      韶关市: {
        code: '440200',
      },
      深圳市: {
        code: '440300',
      },
      珠海市: {
        code: '440400',
      },
      汕头市: {
        code: '440500',
      },
      佛山市: {
        code: '440600',
      },
      江门市: {
        code: '440700',
      },
      湛江市: {
        code: '440800',
      },
      茂名市: {
        code: '440900',
      },
      肇庆市: {
        code: '441200',
      },
      惠州市: {
        code: '441300',
      },
      梅州市: {
        code: '441400',
      },
      汕尾市: {
        code: '441500',
      },
      河源市: {
        code: '441600',
      },
      阳江市: {
        code: '441700',
      },
      清远市: {
        code: '441800',
      },
      潮州市: {
        code: '445100',
      },
      揭阳市: {
        code: '445200',
      },
      云浮市: {
        code: '445300',
      },
    },
  },
  广西: {
    code: '45',
    cities: {
      南宁市: {
        code: '450100',
      },
      柳州市: {
        code: '450200',
      },
      桂林市: {
        code: '450300',
      },
      梧州市: {
        code: '450400',
      },
      北海市: {
        code: '450500',
      },
      防城港市: {
        code: '450600',
      },
      钦州市: {
        code: '450700',
      },
      贵港市: {
        code: '450800',
      },
      玉林市: {
        code: '450900',
      },
      百色市: {
        code: '451000',
      },
      贺州市: {
        code: '451100',
      },
      河池市: {
        code: '451200',
      },
      来宾市: {
        code: '451300',
      },
      崇左市: {
        code: '451400',
      },
    },
  },
  海南: {
    code: '46',
    cities: {
      海口市: {
        code: '460100',
      },
      三亚市: {
        code: '460200',
      },
      三沙市: {
        code: '460300',
      },
      省直辖县级行政区划: {
        code: '4690000',
      },
    },
  },
  重庆: {
    code: '50',
    cities: {
      市辖区: {
        code: '500000',
      },
    },
  },
  四川: {
    code: '51',
    cities: {
      成都市: {
        code: '510100',
      },
      自贡市: {
        code: '510300',
      },
      攀枝花市: {
        code: '510400',
      },
      泸州市: {
        code: '510500',
      },
      德阳市: {
        code: '510600',
      },
      绵阳市: {
        code: '510700',
      },
      广元市: {
        code: '510800',
      },
      遂宁市: {
        code: '510900',
      },
      内江市: {
        code: '511000',
      },
      乐山市: {
        code: '511100',
      },
      南充市: {
        code: '511300',
      },
      眉山市: {
        code: '511400',
      },
      宜宾市: {
        code: '511500',
      },
      广安市: {
        code: '511600',
      },
      达州市: {
        code: '511700',
      },
      雅安市: {
        code: '511800',
      },
      巴中市: {
        code: '511900',
      },
      资阳市: {
        code: '512000',
      },
      阿坝藏族羌族自治州: {
        code: '513200',
      },
      甘孜藏族自治州: {
        code: '513300',
      },
      凉山彝族自治州: {
        code: '513400',
      },
    },
  },
  贵州: {
    code: '52',
    cities: {
      贵阳市: {
        code: '520100',
      },
      六盘水市: {
        code: '520200',
      },
      遵义市: {
        code: '520300',
      },
      安顺市: {
        code: '520400',
      },
      毕节市: {
        code: '520500',
      },
      铜仁市: {
        code: '520600',
      },
      黔西南布依族苗族自治州: {
        code: '522300',
      },
      黔东南苗族侗族自治州: {
        code: '522600',
      },
      黔南布依族苗族自治州: {
        code: '522700',
      },
    },
  },
  云南: {
    code: '53',
    cities: {
      昆明市: {
        code: '530100',
      },
      曲靖市: {
        code: '530300',
      },
      玉溪市: {
        code: '530400',
      },
      保山市: {
        code: '530500',
      },
      昭通市: {
        code: '530600',
      },
      丽江市: {
        code: '530700',
      },
      普洱市: {
        code: '530800',
      },
      临沧市: {
        code: '530900',
      },
      楚雄彝族自治州: {
        code: '532300',
      },
      红河哈尼族彝族自治州: {
        code: '532500',
      },
      文山壮族苗族自治州: {
        code: '532600',
      },
      西双版纳傣族自治州: {
        code: '532800',
      },
      大理白族自治州: {
        code: '532900',
      },
      德宏傣族景颇族自治州: {
        code: '533100',
      },
      怒江傈僳族自治州: {
        code: '533300',
      },
      迪庆藏族自治州: {
        code: '533400',
      },
    },
  },
  西藏: {
    code: '54',
    cities: {
      拉萨市: {
        code: '540100',
      },
      日喀则市: {
        code: '540200',
      },
      昌都市: {
        code: '540300',
      },
      林芝市: {
        code: '540400',
      },
      山南市: {
        code: '540500',
      },
      那曲市: {
        code: '540600',
      },
      阿里地区: {
        code: '542500',
      },
    },
  },
  陕西: {
    code: '61',
    cities: {
      西安市: {
        code: '610100',
      },
      铜川市: {
        code: '610200',
      },
      宝鸡市: {
        code: '610300',
      },
      咸阳市: {
        code: '610400',
      },
      渭南市: {
        code: '610500',
      },
      延安市: {
        code: '610600',
      },
      汉中市: {
        code: '610700',
      },
      榆林市: {
        code: '610800',
      },
      安康市: {
        code: '610900',
      },
      商洛市: {
        code: '611000',
      },
    },
  },
  甘肃: {
    code: '62',
    cities: {
      兰州市: {
        code: '620100',
      },
      金昌市: {
        code: '620300',
      },
      白银市: {
        code: '620400',
      },
      天水市: {
        code: '620500',
      },
      武威市: {
        code: '620600',
      },
      张掖市: {
        code: '620700',
      },
      平凉市: {
        code: '620800',
      },
      酒泉市: {
        code: '620900',
      },
      庆阳市: {
        code: '621000',
      },
      定西市: {
        code: '621100',
      },
      陇南市: {
        code: '621200',
      },
      临夏回族自治州: {
        code: '622900',
      },
      甘南藏族自治州: {
        code: '623000',
      },
    },
  },
  青海: {
    code: '63',
    cities: {
      西宁市: {
        code: '630100',
      },
      海东市: {
        code: '630200',
      },
      海北藏族自治州: {
        code: '632200',
      },
      黄南藏族自治州: {
        code: '632300',
      },
      海南藏族自治州: {
        code: '632500',
      },
      果洛藏族自治州: {
        code: '632600',
      },
      玉树藏族自治州: {
        code: '632700',
      },
      海西蒙古族藏族自治州: {
        code: '632800',
      },
    },
  },
  宁夏: {
    code: '64',
    cities: {
      银川市: {
        code: '640100',
      },
      石嘴山市: {
        code: '640200',
      },
      吴忠市: {
        code: '640300',
      },
      固原市: {
        code: '640400',
      },
      中卫市: {
        code: '640500',
      },
    },
  },
  新疆: {
    code: '65',
    cities: {
      乌鲁木齐市: {
        code: '650100',
      },
      克拉玛依市: {
        code: '650200',
      },
      吐鲁番市: {
        code: '650400',
      },
      哈密市: {
        code: '650500',
      },
      昌吉回族自治州: {
        code: '652300',
      },
      博尔塔拉蒙古自治州: {
        code: '652700',
      },
      巴音郭楞蒙古自治州: {
        code: '652800',
      },
      阿克苏地区: {
        code: '652900',
      },
      克孜勒苏柯尔克孜自治州: {
        code: '653000',
      },
      喀什地区: {
        code: '653100',
      },
      和田地区: {
        code: '653200',
      },
      伊犁哈萨克自治州: {
        code: '654000',
      },
      塔城地区: {
        code: '654200',
      },
      阿勒泰地区: {
        code: '654300',
      },
      省直辖县级行政区划: {
        code: '6590000',
      },
    },
  },
};
